import type { SVGProps } from 'react'

/** PDF format mark — red badge without document chrome (fills icon box). */
export function FileFormatPdfIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <rect x="2" y="2" width="20" height="20" rx="4" fill="#DC2626" />
      <text
        x="12"
        y="15.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="7.5"
        fontWeight="700"
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        PDF
      </text>
    </svg>
  )
}
